import { NgModule } from '@angular/core';

import { CircularProgressIndicatorComponent } from './circular-progress-indicator.component';

@NgModule({
  declarations: [CircularProgressIndicatorComponent],
  exports: [CircularProgressIndicatorComponent],
})
export class CircularProgressIndicatorModule {}
export { CircularProgressIndicatorComponent } from './circular-progress-indicator.component';
